
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {},
  computed: {},
  filters: {},
  watch: {},
})
export default class NewRequest extends Vue {
  seleccione: string = 'seleccione';
  title: string = 'Crear Solicitud';
  branches: any = [];
  branchId: number = 0;

  async mounted() {
    this.$store.commit('clearNewRequest', false);
    this.loadBranches();
  }

  async loadBranches() {
    let companyId = this.$store.state.companyId;
    const response: any = await (this.$root as any)._get(`companies/${companyId}/branches`);
    this.branches = response;
  }
  
  nextStep() {
    if (this.branchId === 0) {
      (this.$root as any).notify('Selecciona un ramo!', 'error');
    } else {
      this.$store.commit('setNewRequestBranch', this.branchId);
      this.$router.push('requests/new-request/conditions');
    }
  }
}
